<template>
  <page-header-wrapper>
    <div class="table-page-search-wrapper">
      <a-form layout="inline" class="table-head-ground">
        <div class="table-layer">
          <!-- 时间筛选器 -->
          <a-form-item label="" style="max-width: 520px; min-width:400px">
            <time-range-filter
              ref="timeRangeFilter"
              :default-type="'today'"
              @change="handleTimeRangeChange"
            />
          </a-form-item>
          <a-form-item label="">
            <jeepay-text-up
              :placeholder="'请输入订单ID'"
              :msg="searchData.orderNo"
              v-model="searchData.orderNo"
            />
          </a-form-item>
          <a-form-item label="" >
            <a-select
              v-model="searchData.transactionCategory"
              placeholder="变更类型"
              style="width: 150px"
              default-value=""
            >
              <a-select-option
                v-for="option in changeTypeOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <!-- 商户号 -->
          <!-- <a-form-item label="" >
            <a-input
              v-model="searchData.mchNo"
              placeholder="商户号"
              style="width: 150px"
            />
          </a-form-item> -->
          <span class="table-page-search-submitButtons">
            <a-button
              type="primary"
              icon="search"
              @click="queryFunc"
              :loading="btnLoading"
            >搜索</a-button>
            <a-button
              style="margin-left: 8px"
              icon="reload"
              @click="resetForm"
            >重置</a-button>
          </span>
        </div>
      </a-form>
    </div>

    <!-- 列表渲染 -->
    <JeepayTable
      @btnLoadClose="btnLoading = false"
      ref="infoTable"
      :initData="true"
      :reqTableDataFunc="reqTableDataFunc"
      :tableColumns="tableColumns"
      :searchData="searchData"
      rowKey="id"
      :tableRowCrossColor="true"
    >
      <!-- 变更类型 -->
      <template slot="transactionCategorySlot" slot-scope="{ record }">
        <a-tag :color="getChangeTypeColor(record.transactionCategory)">
          {{ getChangeTypeText(record.transactionCategory) }}
        </a-tag>
      </template>

      <!-- 变更金额 -->
      <template slot="transactionAmountSlot" slot-scope="{ record }">
        <span
          :class="[
            'amount-text',
            record.transactionType > 0 ? 'amount-positive' : 'amount-negative'
          ]"
        >
          {{ formatChangeAmount(record.transactionAmount, record?.transactionType) }}
        </span>
      </template>

      <!-- 手续费 -->
      <template slot="feeSlot" slot-scope="{ record }">
        <span class="fee-text">
          {{ formatAmount(record.fee) }}
        </span>
      </template>

      <!-- 变更后余额 -->
      <template slot="balanceAfterSlot" slot-scope="{ record }">
        <span class="balance-text">
          {{ formatAmount(record.balanceAfter) }}
        </span>
      </template>

      <!-- 变更前金额 -->
      <template slot="balanceBeforeSlot" slot-scope="{ record }">
        <span class="balance-text">
          {{ formatAmount(record.balanceBefore) }}
        </span>
      </template>

      <!-- 订单时间 -->
      <template slot="transactionTimeSlot" slot-scope="{ record }">
        <span>{{ formatDateTime(record.transactionTime) }}</span>
      </template>

      <!-- 备注 -->
      <template slot="remarkSlot" slot-scope="{ record }">
        <span
          :title="record.remark"
          class="remark-text"
        >
          {{ record.remark || '--' }}
        </span>
      </template>
      <!-- 订单ID -->
      <template slot="orderNoSlot" slot-scope="{ record }">
        <span >{{ record.orderNo || '--' }}</span>
      </template>
    </JeepayTable>

    <!-- 详情弹窗 -->
    <FundFlowDetailModal
      :visible="detailVisible"
      :detailData="detailData"
      @cancel="handleDetailCancel"
    />
  </page-header-wrapper>
</template>

<script>
import JeepayTable from '@/components/JeepayTable/JeepayTable'
import JeepayTextUp from '@/components/JeepayTextUp/JeepayTextUp'
import CopyButton from '@/components/CopyButton/index'
import FundFlowDetailModal from './components/FundFlowDetailModal'
import TimeRangeFilter from '@/components/TimeRangeFilter'
import { tableColumns } from './tableColumns'
import {
  getFundFlowList,
  CHANGE_TYPE_OPTIONS,
  getChangeTypeText,
  getChangeTypeColor
} from '@/api/fundFlow'
// import { formatAmount } from '@/utils/util'
import moment from 'moment'

export default {
  name: 'FundFlowPage',
  components: {
    JeepayTable,
    JeepayTextUp,
    CopyButton,
    FundFlowDetailModal,
    TimeRangeFilter
  },
  data () {
    return {
      btnLoading: false,
      tableColumns: tableColumns,
      searchData: {
        orderNo: ''
      },
      changeTypeOptions: CHANGE_TYPE_OPTIONS,
      detailVisible: false,
      detailData: {}
    }
  },

  methods: {
    // 处理时间范围变化
    handleTimeRangeChange (timeData) {
      this.searchData.startTime = timeData.startTime
      this.searchData.endTime = timeData.endTime
    },

    // 查询按钮
    queryFunc () {
      this.btnLoading = true
      this.$refs.infoTable.refTable(true)
    },

    // 重置表单
    resetForm () {
      this.searchData = {
        orderNo: ''
      }
      this.$nextTick(() => {
         // 如果TimeRangeFilter组件有引用，则调用其重置方法
         if (this.$refs.timeRangeFilter) {
          this.$refs.timeRangeFilter.resetToDefault()
        }
        this.queryFunc()
      })
    },

    // 请求table接口数据
    reqTableDataFunc (params) {
      // 构建查询参数
      const queryParams = {
        ...params,
        orderNo: this.searchData.orderNo,
        transactionCategory: this.searchData.transactionCategory,
        startTime: this.searchData.startTime,
        endTime: this.searchData.endTime
      }

      // 清理空值参数
      Object.keys(queryParams).forEach(key => {
        if (queryParams[key] === '' || queryParams[key] == null) {
          delete queryParams[key]
        }
      })

      return getFundFlowList(queryParams)
    },

    // 查看详情
    viewDetail (record) {
      this.detailData = { ...record }
      this.detailVisible = true
    },

    // 关闭详情弹窗
    handleDetailCancel () {
      this.detailVisible = false
      this.detailData = {}
    },

        // 格式化金额
    formatAmount (amount) {
      if (!amount && amount !== 0) return '₹0.00'
      return `₹${amount}`
      // return formatAmount(amount)
    },
    // 格式化变更金额（显示正负号）
    formatChangeAmount (amount, type = 1) {
      // type = 0  负数 1为正数
      if (!amount && amount !== 0) return '--'
      // const formattedAmount = formatAmount(Math.abs(amount))
      const formattedAmount = amount
      return type === 1 ? `+${formattedAmount}` : `-${formattedAmount}`
    },

    // 获取变更类型文本
    getChangeTypeText,

    // 获取变更类型颜色
    getChangeTypeColor,

    // 格式化日期时间
    formatDateTime (dateTime) {
      console.log('dateTime', dateTime)
      return moment(dateTime).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.table-page-search-wrapper {
  margin-bottom: 16px;
}

.amount-text {
  font-weight: 500;

  &.amount-positive {
    color: #52c41a; // 绿色表示增加
  }

  &.amount-negative {
    color: #ff4d4f; // 红色表示减少
  }
}

.fee-text {
  color: #fa8c16;
  font-weight: 500;
}

.balance-text {
  color: #1890ff;
  font-weight: 500;
}

.order-no-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.order-no-text {
  font-family: 'Courier New', monospace;
  color: #666;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remark-text {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}

.table-head-layout {
  margin-right: 8px;
}

.table-page-search-submitButtons {
  margin-left: 8px;
}
</style>
